import { graphql } from '@graphql/gql';

export const UNREAD_REPORTS = graphql(`
  query UNREAD_REPORTS {
    unreadReports {
      unreadCount
    }
  }
`);
